import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { useIntl } from "gatsby-plugin-intl"

const Container = styled.footer`
  background-color: #b5b1be;
  margin-top: 2rem;
`

const Content = styled.div`
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
`

const FooterComponent = () => {
  const intl = useIntl()

  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Container>
      <Content>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ maxWidth: "300px", width: "100%" }}>
            <Link to="/">
              <Img fluid={data.logo.childImageSharp.fluid} />
            </Link>
          </div>
          <b style={{ color: "white", marginBottom: "4rem", fontFamily: "Caveat", fontSize: "24px" }}>
            {intl.formatMessage({ id: "FOOTER.SUBTITLE" })}
          </b>
          <p style={{ color: "white", textAlign: "center" }}>
            {intl.formatMessage({ id: "FOOTER.COPYRIGHT" })}{" "}
            {new Date().getFullYear()}{" "}
            {intl.formatMessage({ id: "FOOTER.TEXTCOPYRIGHT" })}
          </p>
        </div>
      </Content>
    </Container>
  )
}

export default FooterComponent
